// extracted by mini-css-extract-plugin
export var cardLayout = "_2f-1";
export var paginationContainer = "_2f-0";